import { createApp } from 'vue'
import App from './App.vue'
import 'vue-universal-modal/dist/index.css'

import VueUniversalModal from 'vue-universal-modal'

import DropZone from 'dropzone-vue';
import 'dropzone-vue/dist/dropzone-vue.common.css';

import { createPinia } from "pinia"

import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';

import Antd from 'ant-design-vue';

//Import Froala Editor
import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';
import VueFroala from 'vue-froala-wysiwyg';

//import BussinesCompanies from "@/components/BussinesCompanies.vue";


var element = document.getElementById("app");

if (element !== null) {
  createApp(App)
    .use(DropZone)
    .use(Antd)
    .use(createPinia())
    .use(VueFroala)
    .component('EasyDataTable', Vue3EasyDataTable)
    .use(VueUniversalModal, {
      teleportTarget: '#modals'
    })
    .mount('#app')
}

// var bussines_companies = document.getElementById("bussines_companies");
// console.log(bussines_companies);
//
// if (bussines_companies !== null) {
//
//   const app_product = createApp(BussinesCompanies);
//   app_product.mount('#bussines_companies')
// }



